/*
 * @Description: 竞品数字品牌价值
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-19 17:52:29
 */


import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p27.css';

import P27Chart from './p27.chart';

import {getCompareBrands} from '../../../controller';
import { getSessionQuery } from '../../../utils';
import ExportNav from '../../../components/ExportNav/ExportNav';

const colorList = ['#608f9f', '#014d67', '#56b6a0', '#248e76', '#ffe599'];

class P27 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      list: [],
      component: ''
    };

    this.getData = this.getData.bind(this);
    this.toggleComponent = this.toggleComponent.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.isCustom = query.isCustom
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const that = this;
    const query = this.getQuery();
    if (query.isCustom === '1') {
      this.setState({
        query: query,
        list: query.competingBrands.split(',').map((item, index) => {
          return {
            name: item,
            key: index,
            color: colorList[index]
          }
        })
      }, () => {
        that.toggleComponent(that.state.list[0]);
      })


    } else {
      getCompareBrands({brandName: query.brandName})
        .then(data => {
          this.setState({
            query: query,
            list: data.map((item, index) => {
              return {
                name: item,
                key: index,
                color: colorList[index]
              }
            })
          }, () => {
            that.toggleComponent(that.state.list[0]);
          })
        });
    }

  }

  toggleComponent (item) {
    const query = Object.assign({}, this.state.query, {
      platform: item.key,
      report: true
    });

    this.setState({
      component: ''
    }, () => {
      this.setState({
        component: <P27Chart query={query} name={item.name} color={item.color}></P27Chart>
      });
    });
  }


  render() {
    const {list, component} = this.state;
    return (
      <div className={s.container}>
        <ExportNav
          list={list}
          clickHandle={this.toggleComponent}>
        </ExportNav>

        { component }

      </div>
    );
  }
}

export default withStyles(s)(P27);



// WEBPACK FOOTER //
// src/routes/exportPDF/p27/p27.js